import { client } from "./utils";
import { formatAppListResponse } from "./utils/helpers";

export interface ICreateSalesPurchasesOperation {
  clientDbId: number;
  locale: string;
  clientCode: string;
  module: string;
  documentType: string;
  description: string;
  address?: string | number;
}

export const createSalesPurchasesOperation = (
  params: ICreateSalesPurchasesOperation
) => {
  const query = {
    clientDbId: params.clientDbId,
    procedureName: "RGI_MSCAN_CREATE_RO_PO_DOC",
    data: {
      documentType: params.documentType,
      description: params.description,
      clientCode: params.clientCode,
      module: params.module,
      addressCode: params.address,
    },
  };

  return client
    .post("/client/application", query, {
      headers: {
        "accept-language": params.locale,
      },
    })
    .then(formatAppListResponse);
};

export interface ICreateLocationOperation {
  clientDbId: number;
  locale: string;
  description: string;
  type: string;
}

export const createLocationOperation = (
  params: ICreateLocationOperation
) => {
  const query = {
    clientDbId: params.clientDbId,
    procedureName: "RGI_MSCAN_CREATE_0E_DOC",
    data: { 
      description: params.description,
      type: params.type,
      user: params.clientDbId
    },
  };

  return client
    .post("/client/application", query, {
      headers: {
        "accept-language": params.locale,
      },
    })
    .then(formatAppListResponse);
};

export interface IGetLocationParams {
  clientDbId: number;
  locale: string;
  module: string;
}

export const getLocationParams = (params: IGetLocationParams) => {
  const query = {
    clientDbId: params.clientDbId,
    procedureName: "RGI_MSCAN_GET_0E_PARAMS",
    data: {
      module: params.module,
    },
  };


  return client
    .post("/client/application", query, {
      headers: {
        "accept-language": params.locale,
      },
    })
    .then(formatAppListResponse);
};


export interface IGetParamsList {
  clientDbId: number;
  locale: string;
  module: string;
}

export const getSalesPurchasesParams = (params: IGetParamsList) => {
  const query = {
    clientDbId: params.clientDbId,
    procedureName: "RGI_MSCAN_GET_RO_PO_PARAMS",
    data: {
      module: params.module,
    },
  };

  return client
    .post("/client/application", query, {
      headers: {
        "accept-language": params.locale,
      },
    })
    .then(formatAppListResponse);
};

export interface IGetClientsList {
  clientDbId: number;
  module: string;
  pageNumber: number;
  fil?: string;
}

export const getClientsList = (
  params: IGetClientsList,
  config?: Record<string, unknown>
) => {
  const query = {
    clientDbId: params.clientDbId,
    procedureName: "RGI_MSCAN_GET_RO_PO_CLIENTS",
    data: {
      module: params.module,
      pageNumber: params.pageNumber,
      filter: params.fil || "",
      top: 100,
    },
  };

  return client
    .post("/client/application", query, config)
    .then(formatAppListResponse);
};

export interface IGetAlternativeAddresses {
  clientDbId: number;
  client: string;
  pageNumber: number;
  fil?: string;
  module: string;
}

export const getAlternativeAddresses = (
  params: IGetAlternativeAddresses,
  config?: Record<string, unknown>
) => {
  const query = {
    clientDbId: params.clientDbId,
    procedureName: "RGI_MSCAN_SEARCH",
    data: {
      module: params.module,
      type: "ADDRESS",
      param1: params.client,
      filter: params.fil || "",
      pageNumber: params.pageNumber,
      top: 100,
    },
  };

  return client
    .post("/client/application", query, config)
    .then(formatAppListResponse);
};